import { TButtonTheme } from '@cian/ui-kit/button/types';
import * as React from 'react';

import { FinalStepQuestionLayout } from '../../components';
import { useSetOfferLabel, useE2eLabelTracking } from '../../hooks';
import { FormContext } from '../../utils/formContext';
import { trackAddLabelClick } from '../../utils/tracking';

export const LabelRemovedContainer: React.FC = () => {
  const formContext = React.useContext(FormContext);
  const onTrackAddLabelClick = useE2eLabelTracking(trackAddLabelClick);
  const { isLoading, isError, setOfferLabel } = useSetOfferLabel({
    showLabel: true,
    onSuccess: () => {
      onTrackAddLabelClick({});
      /* istanbul ignore next */
      formContext.onStepYes?.();
    },
  });

  return (
    <FinalStepQuestionLayout
      onButtonClick={setOfferLabel}
      isLoading={isLoading}
      isError={isError}
      changeLabelButtonText="Добавить значок"
      changeLabelButtonTheme={'fill_primary' as TButtonTheme}
    />
  );
};
